export default __webpack_public_path__ + "static/media/MyBox.e8e25562.ico";